import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  authState: any = null;
  constructor(private angularFireAuth: AngularFireAuth) {
    console.log('Initilized ', new Date().getTime());
    this.angularFireAuth.authState.subscribe((auth) => (this.authState = auth));
  }

  loginWithEmail(email: string, password: string) {
    return this.angularFireAuth.signInWithEmailAndPassword(email, password);
  }

  registerWithEmail(email: string, password: string) {
    return this.angularFireAuth.createUserWithEmailAndPassword(email, password);
  }

  logOut() {
    return this.angularFireAuth.signOut();
  }

  getStatus() {
    this.angularFireAuth.authState.subscribe((auth) => (this.authState = auth));
    return this.angularFireAuth.authState;
  }

  get authenticated(): boolean {
    return this.getStatus !== null;
  }
  get currentUserId(): string {
    return this.authenticated ? this.authState.uid : '';
  }

  get firstName(): string {
    return this.authenticated ? this.authState.lastName : 'dep';
  }
}
